import { useCallback } from "react";
import ReusableTable from "./ReusableTable";
import { fetchAllHosts } from "../util/fetchUserUtil";

export const HostsTable = () => {
  const actionButtonsMeta = [
    {
      name: "New Host",
      action: "create_hosts",
    },
  ];

  const fetchData = useCallback(async (postData) => {
    try {
      return await fetchAllHosts();
    } catch (error) {
      const errorMessage =
        error?.response?.data?.data?.errorMessage ||
        error.message ||
        "An unknown error occurred";
      throw new Error(errorMessage);
    }
  }, []);

  return (
    <div className="flex flex-col ">
      <ReusableTable
        key={"hosts"}
        tableType={"hosts"}
        tableName={"Hosts"}
        needGlobalFilter={false}
        needPagination={false}
        onStateChange={fetchData}
        actionButtonsMeta={actionButtonsMeta}
        isExtendingReusableColumns={true}
      />
    </div>
  );
};

export default HostsTable;
